<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <div class="flex-grow-1" :class="backgroundClass" role="main">
      <router-view />
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader.vue";
import TheFooter from "@/components/core/TheFooter.vue";
import TheNavbar from "@/components/core/TheNavbar.vue";

// API for performing CRUD operations from the Datastore
import DatastoreAPI from "@/helpers/DatastoreAPI";

import { mapState, mapGetters, mapActions } from "vuex";

import config from "@/data/config";

export default {
  name: "App",
  mixins: [DatastoreAPI],
  data() {
    return {
      backgroundClass: config.appStyle.backgroundClass
    };
  },
  components: {
    TheHeader,
    TheNavbar,
    TheFooter
  },
  computed: {
    ...mapState("datastore", ["entry", "entryLoaded"]),
    ...mapGetters(["mapToDatastore", "getONID"])
  },
  methods: {
    ...mapActions(["mapFromDatastore"])
  },
  watch: {
    /* Each time the route changes, read from the datastore */
    $route: "readEntry",
    entry() {
      /* When Vuex datastore/entry updates,
      map to Vuex App State */
      this.mapFromDatastore(this.entry);
    },
    entryLoaded() {
      /* When Vuex datastore/entryLoaded updates,
      here is an opportunity to initial */
      if (this.entry === "") {
        // call vuex actions to set your initial state, then call....
        // this.setSomething(value);
        this.updateEntry(this.mapToDatastore);
      }
    },
    getONID() {
      window.BugHerdConfig = window.BugHerdConfig || {};
      window.BugHerdConfig.feedback = { tab_position: "bottom-left" };
      window.BugHerdConfig.reporter = window.BugHerdConfig.reporter || {};
      window.BugHerdConfig.reporter.required = "true";
      window.BugHerdConfig.reporter.email = `${this.getONID}@oregonstate.edu`;
    }
  }
};
</script>
